import React from "react"
import { Col, Container, Row } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={ true }>
          <Row>
            <Col md={ 6 }>© { new Date().getFullYear() } Inforangra.</Col>
            <Col md={ 6 }>
              <div className="text-sm-right d-none d-sm-block">Inforangra</div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
